import { generateUpsellPageUrl, getUpsellOffers } from "../../../common/js/upsells"
import { TrackingManager } from "../../../common/js/services/tracking/trackingManager"

export default () => ({
  internalTracker: new TrackingManager(
    window.trackingConfig.enabledTrackingServices,
    pipelineConfig,
  ),

  init() {
    this.store = Alpine.store("data")

    const data = { segmentUserId: this.store.values.segmentUserId || "" }
    this.internalTracker.isUserIdentified(data).then((isIdentified) => {
      if (!isIdentified) {
        this.internalTracker.trackIdentify({
          customData: {
            email: this.store.values.email,
            segmentUserId: this.store.values.segmentUserId,
          },
        })
      }
    })

    if (this.store.values.lastPaymentMethod && this.store.values.lastPaymentMethod === "primer") {
      this.store.values.isCardSaved = true
    }

    // Save purchased basic offer, as active offer will be overwritten during upsells
    this.store.savePurchasedBasicOffer()

    window.addEventListener("pageshow", () => {
      this.store.trackStatusForAnalytics("PURCHASE")
    })
  },

  proceed() {
    const upsellOffers = getUpsellOffers(pipelineConfig.offers)

    this.internalTracker.trackClick({ clickName: "Continue Clicked" })

    // No upsells provided
    if (upsellOffers.length === 0) {
      this.store.goToLogin()
      return
    }

    // Proceed to upsells starting from the first defined by products
    const firstUpselll = upsellOffers[0]

    const firstUpsellOfferUrl = generateUpsellPageUrl({
      upsellOfferType: firstUpselll.type,
    })

    window.location = firstUpsellOfferUrl
  },
})
